import type { HttpClient } from './http.js';

export interface RecordedSession {
  id: string;
  stage: 'focus' | 'shortBreak' | 'longBreak';
  duration_seconds: number;
  label: string | null;
  completed_at: string;
}

export interface DailyHistoryEntry {
  day: string;
  focusCount: number;
  focusSeconds: number;
  totalCount: number;
}

export interface SessionHistoryResponse {
  tier: 'free' | 'premium';
  window_days: number | null;
  /** Server feature flag + premium — controls whether export buttons show. */
  export_enabled: boolean;
  sessions: RecordedSession[];
  daily: DailyHistoryEntry[];
}

export function createSessionsApi(http: HttpClient) {
  return {
    record(payload: {
      visitor_id: string;
      stage: 'focus' | 'shortBreak' | 'longBreak';
      duration_seconds: number;
      label?: string;
    }): Promise<{ session: RecordedSession }> {
      return http.json('/api/sessions', {
        method: 'POST',
        body: JSON.stringify(payload),
      });
    },

    history(visitorId: string): Promise<SessionHistoryResponse> {
      return http.json(
        `/api/sessions?visitor_id=${encodeURIComponent(visitorId)}`,
      );
    },
  };
}
